import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import styled from 'styled-components';

const PhoneNumberInputWrapper = styled.div`
  .phone-input {
    width: 100% !important;
  }
`;
const PhoneNumberInput = ({
  number,
  setNumber,
  objKey,
  disableDropdown,
  disableCountryCode,
  setSomethingChanged = () => {},
  placeholder = '(555) 555-5555',
}) => (
  <PhoneNumberInputWrapper>
    <PhoneInput
      inputClass='phone-input'
      disableDropdown={disableDropdown}
      disableCountryCode={disableCountryCode}
      country='us'
      countryCodeEditable={!!disableCountryCode}
      onlyCountries={['us']}
      placeholder={placeholder}
      value={number}
      inputStyle={{
        paddingLeft: '40px',
        fontSize: '16px',
        borderRadius: 0,
        borderTop: 'none',
        borderRight: 'none',
        borderLeft: 'none',
      }}
      buttonStyle={{
        borderRadius: 0,
        borderTop: 'none',
        borderRight: 'none',
        borderLeft: 'none',
        background: 'white',
      }}
      onChange={num => {
        setNumber({ [objKey]: num });
        setSomethingChanged(!!num);
      }}
    />
  </PhoneNumberInputWrapper>
);

/** @component */
export default PhoneNumberInput;
